import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-392b1130"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "crew__description" }
const _hoisted_2 = { class: "navigation__button" }
const _hoisted_3 = { class: "photo__crew" }
const _hoisted_4 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass([
      'crew__container',
      { first: _ctx.crews[_ctx.count].name === 'Douglas Hurley' }
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.crews[_ctx.count].job), 1),
      _createElementVNode("h2", null, _toDisplayString(_ctx.crews[_ctx.count].name), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.crews[_ctx.count].description), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(['buttons', { active: _ctx.count === 0 }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.count = 0))
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(['buttons', { active: _ctx.count === 1 }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.count = 1))
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(['buttons', { active: _ctx.count === 2 }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.count = 2))
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(['buttons', { active: _ctx.count === 3 }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.count = 3))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: _ctx.crews[_ctx.count].srcImg,
        alt: `Photo ${_ctx.crews[_ctx.count].name}`
      }, null, 8, _hoisted_4)
    ])
  ], 2))
}